import { useTranslation } from 'react-i18next';

import type { UserFunction } from '../../../shared/types';
import { AutocompleteMultipleField, type AutocompleteMultipleFieldProps } from '../../fields/AutocompleteMultipleField';
import type { DailyTasksFormFilerValue } from '../lib/types';

export type UserFunctionFieldProps = Omit<
  AutocompleteMultipleFieldProps<DailyTasksFormFilerValue, 'userFunctions', UserFunction>,
  'name' | 'label' | 'getOptionLabel' | 'renderOption'
>;

export const UserFunctionField = (props: UserFunctionFieldProps) => {
  const { t } = useTranslation();

  return (
    <AutocompleteMultipleField
      {...props}
      name='userFunctions'
      label={t('user-function')}
      getOptionLabel={(userFunction) => userFunction.name}
      renderOption={(liProps, userFunction) => <li {...liProps}>{userFunction.name}</li>}
    />
  );
};
